// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__Fzisd","withMobileMargins":"DateRangeInput_withMobileMargins__-3cRk","arrowIcon":"DateRangeInput_arrowIcon__35-sP"};